function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 125 77"
}, props), React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  fill: "#11BB9A",
  d: "M0 0h125v77H0z"
}), React.createElement("path", {
  d: "M62.538 14l26.448 20.04H36.09L62.538 14zM35.817 58.535h53.442v5.09H35.817zM43.452 54.718V38.176h6.362v16.542zM59.994 54.718V38.176h6.362v16.542zM75.263 54.718V38.176h6.362v16.542z",
  fill: "#fff"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h125v77H0z"
})))));